import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import Sidebar from "./Sidebar";

export default function ExcelExport({ excelData, fileName, url, filter }) {
 // console.log("I received the following: ", filter);

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheethtml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  async function getValuesWithoutPagination() {
    //Generate query string
    const query = Object.keys(filter)
      .filter((key) => filter[key] !== "")
      .map((key) => `${key}=${filter[key]}`)
      .join("&");

     // console.log(url + "?" + query)
    //Get response
    const response = await fetch(url + "?" + query, {
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    });

    //Returns prices
    const data = await response.json();
    return data.prices;
  }

  const exportToExcel = async () => {
    let downloadData = url && filter ? await getValuesWithoutPagination() : excelData;

    if(!downloadData){
      alert("Data is not available.")
      return
    }
    
    const ws = XLSX.utils.json_to_sheet(downloadData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  return (
    <button
      class="btn btn-block table-buttons"
      onClick={() => {
        exportToExcel(fileName);
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-download"
        viewBox="0 0 16 16"
      >
        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
      </svg>{" "}
      Download xlsx
    </button>
  );
}
